import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { send_request } from '../../../utils/Request';
import ConfirmDestructiveActionDialog from '../../W86Components/ConfirmDestructiveActionDialog';

function ConfirmResumeAllPausedDialog({ isOpen, close, pausedCount, resumeAllPaused }) {
  const [user, setUser] = useState(null);
  const [isResuming, setIsResuming] = useState(false);

  useEffect(() => {
    if (!isOpen || user) return undefined;

    let cancelled = false;
    const loadUsername = async () => {
      const json = await send_request(`authz-service/user-info`, '', {});
      if (!cancelled && json && json.data) setUser(json.data.displayName);
    };
    loadUsername();

    return () => {
      cancelled = true;
    };
  }, [isOpen, user]);

  const count = pausedCount || 0;

  return (
    <ConfirmDestructiveActionDialog
      open={isOpen}
      title="Resume all paused sessions"
      headerDetail={
        <>
          <strong>
            {user || <Skeleton variant="text" width={125} sx={{ display: 'inline-block' }} />}
          </strong>{' '}
          is resuming all paused sessions
        </>
      }
      warning={
        <>
          This resumes every paused session for this workflow from where it paused. Sessions were
          paused because you ran out of session quota — if you're still over quota they'll pause
          again. Resuming consumes session quota.
        </>
      }
      confirmLabel="Resume Paused Sessions"
      loading={isResuming}
      manageLoading={false}
      confirmDisabled={count === 0}
      onClose={close}
      onConfirm={async () => {
        setIsResuming(true);
        try {
          await resumeAllPaused();
          close();
        } finally {
          setIsResuming(false);
        }
      }}
    />
  );
}

export default ConfirmResumeAllPausedDialog;
